import Otp from "../../../../jsx/pages/Customer/Otp";

const LoginWrapper = function () {
  return <Otp />;
};

export default constore(LoginWrapper);
